import React from "react";
import { Select } from "react-materialize";

function AuctionFilter({ setAuctionFilter }) {
  return (
    <Select
      // className="custom-width-dropdown"
      multiple={false}
      options={{
        classes: "browser-default",
        dropdownOptions: {
          alignment: "left",
          autoTrigger: true,
          closeOnClick: true,
          constrainWidth: true,
          coverTrigger: false,
        },
      }}
      onChange={(e) => setAuctionFilter(e.target.value)}
    >
      <option value="">All Auction</option>
      <option value="forwardAuction">Forward Auction</option>
      <option value="reverseAuctionService">Service Auction</option>
      <option value="reverseAuctionProduct">Product Auction</option>
    </Select>
  );
}

export default AuctionFilter;
